/*
 * @Author: jinxiong
 * @Date: 2022-10-24 10:44:17
 * @LastEditTime: 2022-10-31 17:37:28
 * @Description: Do not edit
 */
import Vue from 'vue';
import App from './App.vue';
import router from './router';
import store from './store';

Vue.config.productionTip = false;

// 导入element-ui

import './element/index';
import 'element-ui/lib/theme-chalk/index.css';

// 导出公共的样式
import 'bootstrap/dist/css/bootstrap.css'; //引用bootstrap的样式
import 'bootstrap/dist/js/bootstrap.min.js'; //引用bootstrap的js
import '@/utils/base.css';
import '@/utils/lib/flexible.js';
import '@/assets/css/theme.css';

let scrollWidth = document.documentElement.scrollWidth;
window.addEventListener('resize', () => {
  scrollWidth = document.documentElement.scrollWidth;
  Vue.prototype.WIDTH = scrollWidth;
});
Vue.prototype.WIDTH = scrollWidth;

import VueAMap from 'vue-amap';
Vue.use(VueAMap);

// 初始化vue-amap
// VueAMap.initAMapApiLoader({
//   key: '56b4d8432afaf8ab763df716e8db5412', // 高德的key
//   // 插件集合
//   plugin: [
//     // "AMap.CircleEditor", // 圆形编辑器插件
//     // "AMap.Geolocation", // 定位控件，用来获取和展示用户主机所在的经纬度位置
//     // "AMap.Geocoder", // 地理编码与逆地理编码服务，用于地址描述与坐标间的相互转换
//     // "AMap.Autocomplete",
//     // "AMap.PlaceSearch",
//     // "AMap.CitySearch",
//     'AMap.Autocomplete',
//     'AMap.PlaceSearch',
//     'AMap.Scale',
//     'AMap.OverView',
//     'AMap.ToolBar',
//     'AMap.MapType',
//     'AMap.PolyEditor',
//     'AMap.CircleEditor',
//     'AMap.Geolocation',
//   ],
//   // 高德 sdk 版本，默认为 1.4.4
//   v: '1.4.4',
// });
// //高德的安全密钥
// window._AMapSecurityConfig = {
//   securityJsCode: 'cab65f499de103466f850e3849965286',
// };

new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount('#app');
